import PropTypes from 'prop-types';

const overViewPropTypes = {
  overview: PropTypes.shape({
    description: PropTypes.string,
    type: PropTypes.string,
    status: PropTypes.string,
    period: PropTypes.string,
    endDate: PropTypes.string,
    startDate: PropTypes.string,
    isUnlimited: PropTypes.bool,
    usage: PropTypes.shape({
      valueType: PropTypes.string,
      value: PropTypes.number,
    }),
    total: PropTypes.shape({
      valueType: PropTypes.string,
      value: PropTypes.number,
    }),
  }),
  usage: PropTypes.shape({
    period: PropTypes.shape({
      usageInterval: PropTypes.string,
      usageDuration: PropTypes.string,
    }),
    usage: PropTypes.arrayOf(
      PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        usage: PropTypes.shape({
          valueType: PropTypes.string,
          value: PropTypes.string,
        }),
      }),
    ),
  }),
};

export default overViewPropTypes;
